import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  input,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IPrevision, IPrevisionUi } from '@models/IPrevisiones';
import { TranslateModule } from '@ngx-translate/core';
import { bloquearCientifica } from '@utils/bloquearCientifica';

@Component({
  selector: 'app-previsiones-table-readonly',
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [DatePipe],
  templateUrl: './previsiones-table-readonly.component.html',
  styleUrl: './previsiones-table-readonly.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrevisionesTableReadonlyComponent {
  bloquearCientifica = bloquearCientifica;
  readonly previsiones = input<IPrevision[]>([]);
  readonly editable = input<boolean>(false);
  readonly festivos = input<Date[]>([]);

  isFestivo(date: string) {
    return this.festivos().some(
      (f) => f.toDateString() === new Date(date).toDateString(),
    );
  }
}
